export const EventStates = {
  SAVED: 'saved',
  NEW: 'new',
  MODIFIED: 'modified',
} as const;
